import z from 'zod/v4'

export const latLngSchema = z.object({
  lat: z.number(),
  lng: z.number(),
})

export type LatLng = z.infer<typeof latLngSchema>

export const latLngBoundsSchema = z.object({
  north: z.number(),
  south: z.number(),
  east: z.number(),
  west: z.number(),
})

export type LatLngBounds = z.infer<typeof latLngBoundsSchema>

export function isLatLngBounds(geometry: unknown): geometry is LatLngBounds {
  return !!geometry && typeof geometry === 'object' && 'east' in geometry
}

export function isLatLng(geometry: unknown): geometry is LatLng {
  return !!geometry && typeof geometry === 'object' && 'lat' in geometry && 'lng' in geometry
}

export function isPolygon(geom: unknown): geom is LatLng[] {
  return Array.isArray(geom) && geom.length > 1 && isLatLng(geom[0])
}

export type GeometryType = LatLng[] | LatLng | LatLngBounds | LatLngBounds[] | LatLng[][]

export function isBasicGeometryType(value: unknown): value is GeometryType {
  return isLatLng(value) || isLatLngBounds(value) || isPolygon(value)
}

export function isGeometryType(value: unknown): value is GeometryType {
  return isBasicGeometryType(value) || (Array.isArray(value) && isBasicGeometryType(value[0]))
}
